interface IIconExcelMasterRex {
  fill?: string;
  disabled?: boolean;
}

/** "R" de Rex+, para el botón que genera el Excel Master. */
export default (props: IIconExcelMasterRex) => {
  const { fill, disabled } = props;

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={disabled ? "#aeaeae" : fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="10"
        y="10.5"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="16"
        fontWeight="700"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        R
      </text>
    </svg>
  );
};
